import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';
import Figure from '../../Figure/index.jsx';

import Column from './base.jsx';

import ColumnLabels from '@data/nft-collections/columns.json';


var columnOptions = {
  id: 'j',
  title: 'Total Supply'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get overlayText() {
    return ColumnLabels.totalSupply.description;
  }

  get rightAlign() {
    return true;
  }
}


var DetailColumn = function(props) {
  return (
    <td className="text-right">
      <Figure amount={props.row.totalSupply} includeDecimals={false} zeroIsBlank />
    </td>
  );
}


class TotalSupply extends Column {
  get default() {
    return true;
  }

  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.totalSupply < b.totalSupply) {
      return -1;
    }
    if (a.totalSupply > b.totalSupply) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.totalSupply < b.totalSupply) {
      return 1;
    }
    if (a.totalSupply > b.totalSupply) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default TotalSupply;

